'use client';

import { useFormStatus } from 'react-dom';
import { LoaderIcon } from '@/components/icons';
import { Button } from './ui/button';
import { cn } from '@/lib/utils';

export function SubmitButton({
  children,
  className,
  size,
}: {
  children: React.ReactNode;
  className?: string;
  size?: 'default' | 'sm' | 'lg' | 'icon';
}) {
  const { pending } = useFormStatus();

  return (
    <Button
      type={pending ? 'button' : 'submit'}
      aria-disabled={pending}
      disabled={pending}
      className={cn('relative', className)}
      size={size}
    >
      {children}

      {pending && (
        <span className="animate-spin absolute right-4">
          <LoaderIcon />
        </span>
      )}

      <output
        aria-live="polite"
        className="sr-only"
      >
        {pending ? 'Loading' : 'Submit form'}
      </output>
    </Button>
  );
}

export function FormButton({
  children,
  onClick,
  className,
  size,
}: {
  children: React.ReactNode;
  onClick: () => void;
  className?: string;
  size?: 'default' | 'sm' | 'lg' | 'icon';
}) {
  const { pending } = useFormStatus();

  return (
    <Button
      aria-disabled={pending}
      disabled={pending}
      className={cn('relative', className)}
      size={size}
      onClick={onClick}
    >
      {children}
    </Button>
  );
}
